<template>
  <div id="app">
    <header>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M19.1,8.7C20.9,10.5 20.9,13.3 19.1,15.2L20.1,16.2C22.6,13.9 22.6,10.1 20.1,7.7L19.1,8.7M18,9.8L17,10.8C17.5,11.5 17.5,12.4 17,13.1L18,14.1C19.2,12.9 19.2,11.1 18,9.8M14,1H4A2,2 0 0,0 2,3V21A2,2 0 0,0 4,23H14A2,2 0 0,0 16,21V3A2,2 0 0,0 14,1M14,20H4V4H14V20Z" /></svg>
      <span>Text to Speak</span>
      <span class="right"></span>
    </header>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>

export default {
  name: 'app',
  methods: {
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  margin-top: 5px;
  padding: 0 10px;
}

header {
  margin: 0;
  height: 44px;
  padding: 0 16px 0 14px;
  background-color: #35495E;
  color: #ffffff;
  fill: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

header img {
  align-items: flex-start;
}

header .right {
  opacity: 0;
}

header span {
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue